import { BrandIcon } from "@ui/BrandIcon";
import { ListTitle } from "@ui/ListTitle";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { HStack, VStack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";
import { getPlatformIcon } from "@utils/platform";
import { For, Show } from "solid-js";
import { askPageLinkPlatformDef } from "~/modules/askgvt/my-ask-page/askPageLinkCatalog";
import { formatCount, myAskPageUrl, viewerIsOwner } from "../askPageAccess";
import { askPageVars } from "../pageVars";
import { AskPageEmptyState } from "./AskPageEmptyState";

export const ConnectedChannels = () => {
	const vars = askPageVars();
	const channels = () =>
		vars.social_channels.filter((channel) => channel.profile_url);
	return (
		<Show
			when={channels().length > 0}
			fallback={
				<Show when={viewerIsOwner(vars.status)}>
					<AskPageEmptyState
						symbol="link"
						title="Add your links"
						body="Show visitors where else to find you: YouTube, Instagram, X or your website."
						action={{ label: "Add links", href: myAskPageUrl("page") }}
					/>
				</Show>
			}
		>
			<VStack spacing="large">
				<HStack align="center" spacing="large">
					<ListTitle>
						Where else to find {vars.influencer_display_name}
					</ListTitle>
				</HStack>
				<div class="askgvt1-channels">
					<For each={channels()}>
						{(channel) => (
							<a
								href={channel.profile_url ?? "#"}
								target="_blank"
								rel="noopener noreferrer"
							>
								<Show
									when={getPlatformIcon(channel.platform)}
									fallback={
										<span aria-hidden="true">
											<MaterialSymbol
												symbol={
													askPageLinkPlatformDef(channel.platform)
														?.addSymbol ?? "link"
												}
											/>
										</span>
									}
								>
									<BrandIcon platform={channel.platform} fillWithCurrentColor />
								</Show>
								{askPageLinkPlatformDef(channel.platform)?.addLabel ??
									(channel.platform === "website"
										? channel.handle
										: channel.platform)}
								<Show when={channel.follower_count != null}>
									<Text
										as="span"
										family="mono"
										transform="uppercase"
										size="xsmall"
										color="fg3"
									>
										{formatCount(channel.follower_count)}
									</Text>
								</Show>
							</a>
						)}
					</For>
				</div>
			</VStack>
		</Show>
	);
};
